export const Data = [
    { name: "HTML", level: "advanced", icon: "fab fa-html5", type: "dev-web" },
    { name: "CSS", level: "intermediate", icon: "fab fa-css3-alt", type: "dev-web" },
    { name: "JavaScript", level: "basic", icon: "fab fa-js", type: "dev-web" },
    { name: "MAUI", level: "intermediate", icon: "fas fa-mobile-alt", type: "dev-mobile" },
    { name: "C#", level: "intermediate", icon: "fab fa-cuttlefish", type: "programming" },
    { name: "C", level: "basic", icon: "fas fa-c", type: "programming" },
    { name: "Shell", level: "intermediate", icon: "fas fa-terminal", type: "dev-ops" },
    { name: "React", level: "intermediate", icon: "fab fa-react", type: "dev-web" },
    { name: "Symfony", level: "intermediate", icon: "fab fa-symfony", type: "dev-web" },
    { name: "Rancher Desktop", level: "advanced", icon: "fas fa-desktop", type: "dev-ops" },
    { name: "Git", level: "intermediate", icon: "fab fa-git-alt", type: "dev-ops" },
    { name: "GitLab", level: "intermediate", icon: "fab fa-gitlab", type: "dev-ops" },
    { name: "Canva", level: "intermediate", icon: "fas fa-chalkboard", type: "utils" },
    { name: "Node.js", level: "basic", icon: "fab fa-node-js", type: "dev-web" },
    { name: "Python", level: "intermediate", icon: "fab fa-python", type: "programming" },
    { name: "Angular", level: "intermediate", icon: "fab fa-angular", type: "dev-web" },
    { name: "Swift", level: "intermediate", icon: "fab fa-swift", type: "dev-mobile" },
    { name: "PostgreSQL", level: "intermediate", icon: "fas fa-database", type: "bdd" },
    { name: "MongoDB", level: "basic", icon: "fab fa-envira", type: "bdd" },
    { name: "MariaDB", level: "intermediate", icon: "fab fa-mdb", type: "bdd" },
];
